import React from 'react';
import { Box, HStack, Menu, MenuButton, MenuList, MenuItem, Input, Button } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import useAmbulanceMap from '../../hooks/useAmbulanceMap';
import { MapView } from '../../GlobalComponent/MapView/MapView';
import { ColorLegend } from '../../GlobalComponent/ColorLegend/ColorLegend';
import { Company } from '../../Interfaces/Company';

interface AmbulanceMapProps {
  companies: Company[];
  isActive?: boolean;
}

const AmbulanceMap: React.FC<AmbulanceMapProps> = ({ companies, isActive = true }) => {
  const {
    loading,
    filteredCompanies,
    selectedCompanyName,
    clusters,
    setSelectedCompany,
    searchTerm,
    setSearchTerm,
    isOpen,
    setIsOpen,
    inputRef,
  } = useAmbulanceMap({ companies });

  return (
    <Box width={"98%"}>
      <HStack spacing={4} mb={4} align="start">
        <Menu isOpen={isOpen} onClose={() => setIsOpen(false)}>
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon />}
            onClick={() => setIsOpen(!isOpen)}
            width="300px"
            textAlign="left"
          >
            {selectedCompanyName || "Select a company"}
          </MenuButton>
          <MenuList maxH="300px" overflowY="auto">
            <Box p={2} onClick={(e) => e.stopPropagation()}>
              <Input
                ref={inputRef}
                placeholder="Search companies..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setTimeout(() => inputRef.current?.focus(), 0);
                }}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                    e.preventDefault();
                  }
                }}
                onFocus={(e) => e.stopPropagation()}
                size="sm"
                autoComplete="off"
              />
            </Box>
            {filteredCompanies.map((company) => (
              <MenuItem
                key={company._id}
                onClick={() => {
                  setSelectedCompany(company._id);
                  setSearchTerm("");
                  setIsOpen(false);
                }}
              >
                {company.companyName}
              </MenuItem>
            ))}
            {filteredCompanies.length === 0 && (
              <MenuItem isDisabled>
                No companies found
              </MenuItem>
            )}
          </MenuList>
        </Menu>
        <ColorLegend items={[
          { color: 'red', label: 'Pickup Location' },
          { color: 'green', label: 'Drop Location' },
          { color: 'purple', label: 'Mixed' }
        ]} />
      </HStack>

      {!loading ? <MapView clusters={clusters} isActive={isActive} /> : <Box p={4}>Loading map data...</Box>}
    </Box>
  );
};

export default AmbulanceMap;